import { render, staticRenderFns } from "./NotificationPopup.vue?vue&type=template&id=0faf97ba"
import script from "./NotificationPopup.vue?vue&type=script&lang=js"
export * from "./NotificationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScContactDetails: require('/opt/build/repo/node_modules/@evince/site/lib/packages/contact/Details.vue').default})
